import useStoreWebsiteDataToLocalStorage from "./hooks/App/useStoreWebsiteDataToLocalStorage";
import AppRoutes from "./Routes/AppRoutes";

function App() {
  useStoreWebsiteDataToLocalStorage();
  // useChangeLangDirOnKeys();

  return <AppRoutes />;
}

export default App;
